// グリッド吸着のうち「ストアの設定を参照する」層。
//
// 純関数の snapToGrid は、ストアへ依存しないよう lib/canvas-coordinates.ts が正本として持つ。
// 決定的ロジック（connector-auto-create.ts）はそちらだけを使い、このモジュールには依存しない。
// ここには UI 層（canvas-stage.tsx など）から使う「吸着設定を見て丸めるかどうか決める」薄い
// ラッパーだけを置く。
import { snapToGrid } from "../../lib/canvas-coordinates";
import { useCanvasStore } from "./store/canvas-store";

/** グリッド吸着 ON のとき指定座標を格子へ丸める。OFF のときは何もしない。 */
export function snapPointIfGridEnabled(point: { readonly x: number; readonly y: number }): {
  x: number;
  y: number;
} {
  if (!useCanvasStore.getState().gridSnapEnabled) return { x: point.x, y: point.y };
  return { x: snapToGrid(point.x), y: snapToGrid(point.y) };
}
